<template>
<div>
	<!--<h1>NodeContainer [{{nodeId}}]</h1>-->
	<template v-if="initialized">
		<router-view v-if="!notFound && authorized" />
		<node-login :nodeId="nodeId" v-if="!notFound && !authorized"></node-login>
		<error-404 v-if="notFound" heading="Ecosystem Node Not Found">
			Node [{{nodeId}}] could not be found!
		</error-404>
	</template>
</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Error404 from '@/components/Error404';
import NodeLogin from '@/components/NodeLogin';
import { setInterval } from 'timers';


export default {
	name: "node-view",
	props: [ 'nodeId' ],
	components: { Error404, NodeLogin },
	data() {
		return {
			initialized : false,
			notFound : false,
			routeParams : this.$route.params,	// TRICK!!! YOu must do this, to be able to listen on param changes!!!
		};
	},
	computed:
	{
		...mapGetters( "authentication", [
			"activeSession",
			"activeSessionLookup",
			"session"
		]),
		currentSession : function( )
		{
			try {
				return this.session( this.activeSession( this.nodeId ) );
			} catch( err ) {
				return null;
			}
		},
		authorized : function( )
		{
			return ( this.$route.meta.public && !this.routeParams.forceLogin ) || null != this.currentSession;
		},
	},
	watch:
	{
		'$route.path' : async function( newValue, oldValue )
		{
			this.initialized = false;
			await this.checkNode( );
		}
	},
	methods: {
		...mapActions({
			findNode: "nodes/findNode"
		}),
		async checkNode( )
		{
			try {
				let result = await this.findNode( { id : this.nodeId } );
				console.log( result );
				if( result )
				{
					console.log( "[NodeContainer] Node '"+ this.nodeId +"' found!" );
					this.notFound = false;
				}
				else
				{
					console.log( "[NodeContainer] Could not find node '"+ this.nodeId +"'" );
					this.notFound = true;
				}
			} catch( err ) {
				throw err;
			}
			this.initialized = true;
		},
	},
	async created( )
	{
		await this.checkNode( );
	},
};
</script>


// WEBPACK FOOTER //
// src/components/containers/NodeContainer.vue